module.exports = __webpack_public_path__ + "static/media/ferianavidad.f74bd83a.webp";